import PropTypes from 'prop-types';
import React, {useState} from 'react';

import {useChatStore} from '../../../store/slices/chatStore';
import {useLogoutStore} from '../../../store/slices/logoutStore';
import MessageText from '../MessageText/MessageText';
import './MessageAccreditationCancel.style.scss';

export const MessageAccreditationCancel = (props) => {
  const actionLogout = useLogoutStore((state) => state.actionLogout);
  const messagesContinue = useLogoutStore((state) => state.messagesContinue);
  const typeContinue = useLogoutStore((state) => state.typeContinue);
  const flowContinue = useLogoutStore((state) => state.flowContinue);
  const setGoLogout = useLogoutStore((state) => state.setGoLogout);
  const setMessages = useChatStore((state) => state.setMessages);
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const responseFlowChange = useChatStore((state) => state.responseFlowChange);
  const [hiddenButtons, setHiddenButtons] = useState(true);

  const accreditationContinue = () => {
    setHiddenButtons(false);

    let messages = [
      {
        text: 'Continuar credenciamento',
        type: 'response-sent'
      }
    ];

    messages.push(messagesContinue);
    setMessages(messages);
    responseTypeChange(typeContinue);
    responseFlowChange(flowContinue);
    setGoLogout(!actionLogout);
  };

  const accreditationClose = () => {
    setHiddenButtons(false);

    let messages = [
      {
        text: 'Sair',
        type: 'response-sent'
      },
      {
        text: 'Ah, que pena! Estamos aqui para ajudá-lo sempre que precisar. Se você mudar de ideia, estaremos aqui te esperando!',
        type: 'message-accreditation-close'
      }
    ];

    setMessages(messages);
    responseTypeChange('disabled');
  };

  return (
    <>
      <MessageText
        id={props.question.id}
        text={props.question.text}
        html_id="message-sair-credenciamento"
        data-testid="message-sair-credenciamento"
        data-aut-test="message-sair-credenciamento"
      />
      {hiddenButtons && (
        <div className="message-line" id="select-option">
          <div className="div-button" id="msg-">
            <button
              className="button-option-cancel"
              type="button"
              id="btn-continue-accreditation"
              data-testid="btn-continue-accreditation"
              onClick={() => accreditationContinue()}
            >
              CONTINUAR CREDENCIAMENTO
            </button>
            <button
              className="button-option-cancel"
              id="btn-go-out-accreditation"
              data-testid="btn-go-out-accreditation"
              type="button"
              onClick={() => accreditationClose()}
            >
              SAIR
            </button>
          </div>
        </div>
      )}
    </>
  );
};

MessageAccreditationCancel.propTypes = {
  question: PropTypes.object
};
